import { Box, CircularProgress } from "@mui/material";
import React from "react";
import logo from "../assets/images/logo.png";
import { Helmet } from "react-helmet-async";

const Loader = () => {
  return (
    <>
      <Helmet>
        <title>{process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <img src={logo} alt="logo" style={{ width: "32px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
            position: "absolute",
          }}
        >
          <CircularProgress color="primary" size={60} thickness={1.5} />
        </Box>
      </Box>
    </>
  );
};

export default Loader;
